<div class="list">
  <ng-container *ngIf="!!items; else tmpLoading">
    <ng-container *ngIf="items.length; else tmpNoData">
      <app-chats-list-item
        *ngFor="let item of items"
        class="list-item"
        [ngClass]="item.chatId === selectedId ? 'list-item_selected' : ''"
        [item]="item"
        (click)="onChangeSelectedId(item.chatId, item.isChatMember)"
      ></app-chats-list-item>
    </ng-container>
  </ng-container>
</div>

<ng-template #tmpLoading>
  <app-skeleton-wrapper [loading]="true"></app-skeleton-wrapper>
</ng-template>

<ng-template #tmpNoData>
  <div class="no-data">
    <p>{{ 'components.internalMessenger.labels.noData' | translate }}</p>
  </div>
</ng-template>
